import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VueReCaptcha } from "vue-recaptcha-v3";

// Google reCAPTCHA site key for digiprod.ca
const RECAPTCHA_SITE_KEY = "6Lf02f4rAAAAAC2mcRPEOyd2D_tMQ7qWecaJJpIA";

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueReCaptcha, {
  siteKey: RECAPTCHA_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

app.mount("#app");
